import React, { useState } from "react";
import axios from "axios";
import { TSLogoDark } from "../../../Routes/ImagePath";
import Footer from "../../layout/Footer";
import { getApiUrl } from "../../../utils/AuthUtils";

// Public, no-login document checker. Anyone with a reference code (printed
// on a signed copy report) and the file itself can confirm it's still
// exactly what AMS issued - primarily meant for the finance team to check a
// vendor's upload in the ERP system. Talks to /api/public/verify-document,
// which is deliberately outside the authenticated API - see
// eor-backend-apis/api/signedCopyReports/publicVerify.routes.js.
const VerifyDocument = () => {
  const entityLogo = localStorage.getItem("entity_logo");
  const entityName = localStorage.getItem("entity_name");

  const [referenceCode, setReferenceCode] = useState("");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    const picked = e.target.files && e.target.files[0];
    setFile(picked || null);
    setFileName(picked ? picked.name : "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setResult(null);

    if (!referenceCode.trim()) {
      setError("Enter the reference code printed on the document.");
      return;
    }
    if (!file) {
      setError("Choose the PDF file to check.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("referenceCode", referenceCode.trim());
      formData.append("file", file);

      const res = await axios.post(
        `${getApiUrl()}/api/public/verify-document`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setResult(res.data.data);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Unable to check this document right now. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const isValid = result?.overallStatus === "VALID";

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <img src={entityLogo || TSLogoDark} alt="" />
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                {entityName && <h2 className="account-title">{entityName}</h2>}
                <h3 className="account-title">Document Verification</h3>
                <p className="account-subtitle">
                  Enter the reference code printed on the signed copy report
                  and upload the file to confirm it hasn't been altered.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label>Reference Code</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="e.g. TSNYVE014"
                      value={referenceCode}
                      onChange={(e) => setReferenceCode(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                  <div className="input-block">
                    <label>Document (PDF)</label>
                    <input
                      className="form-control"
                      type="file"
                      accept="application/pdf"
                      onChange={handleFileChange}
                    />
                    {fileName && (
                      <small className="text-muted">{fileName}</small>
                    )}
                  </div>
                  <div className="input-block text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Validating..." : "Validate Document"}
                    </button>
                  </div>

                  {error && (
                    <div className="alert alert-danger mt-3">{error}</div>
                  )}

                  {result && (
                    <div
                      className={`alert mt-3 ${
                        isValid ? "alert-success" : "alert-danger"
                      }`}
                    >
                      <strong>
                        {isValid ? "✓ Valid Document" : "Invalid Document"}
                      </strong>
                      <p className="mb-0" style={{ marginTop: 6 }}>
                        {result.reason}
                      </p>
                    </div>
                  )}
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyDocument;
